import React from "react";
import { nanoid } from "nanoid";
import { CSSTransition } from "react-transition-group";
import MenuFilterButton from "./Filters/MenuFilterButton";

const FilterButtonDropdownMenu = (props) => {
  const {
    filterButtonsOpen,
    filterButtons,
    setFilters,
    currentFilters,
    currentOption,
  } = props;

  const dropdownButtons = filterButtons
    .sort((a, b) => a.localeCompare(b))
    .map((filterButtonText) => (
      <MenuFilterButton
        onClick={setFilters}
        key={nanoid()}
        text={filterButtonText}
        value={filterButtonText}
        currentFilters={currentFilters}
        currentOption={currentOption}
      />
    ));

  return (
    <section>
      <CSSTransition in={filterButtonsOpen} timeout={300} classNames="buttons">
        <div className="tw-grid tw-bg-white tw-w-full tw-grid-cols-1 tw-max-w-xs md:tw-max-w-full filters tw-mx-auto sm:tw-grid-cols:3 md:tw-grid-cols-4 tw-gap-4 tw-pb-4">
          {dropdownButtons}
        </div>
      </CSSTransition>
    </section>
  );
};

export default FilterButtonDropdownMenu;
